module.exports = __webpack_public_path__ + "static/images/containers/Stronghold/components/Direction/components/Building/images/home-front-service-lvl2-100.c35f8e5b.png";


//////////////////
// WEBPACK FOOTER
// ./containers/Stronghold/components/Direction/components/Building/images/home-front-service-lvl2-100.png
// module id = 3311
// module chunks = 11